import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "store";
import { Button } from "design_system/src";
import { ReactComponent as User } from "design_system/src/static/icons/user-card.svg";
import {
  clearApplicationLoanTime,
  clearApplicationPartnership,
  clearApplicationVehicle,
} from "store/actions/application";
import { ApplicationStatusButton } from "./ApplicationStatusButton";

type Props = {
  className?: string;
  fullWidth?: boolean;
};

export const AccountButton: React.FC<Props> = ({ className, fullWidth = false }) => {
  const dispatch = useDispatch();
  const tempToken = useSelector((state: RootState) => state.userReducer.tempToken);
  const accessToken = useSelector((state: RootState) => state.userReducer.accessToken);
  const user = useSelector((state: RootState) => state.userReducer.user);

  const isAccessTokenSession = !!accessToken;
  const isTempTokenSession = !!tempToken && !accessToken;

  const goLoan = () => {
    dispatch(clearApplicationLoanTime());
    dispatch(clearApplicationVehicle());
    dispatch(clearApplicationPartnership());
  };

  if (isAccessTokenSession) {
    return (
      <Link to="/mi-cuenta" onClick={goLoan} className={className}>
        <Button
          variant="principal"
          color="primary"
          icon={<User />}
          scale="small"
          className={fullWidth ? "w_100_per" : ""}
        >
          Bienvenid@ {user?.firstName}
        </Button>
      </Link>
    );
  }

  if (isTempTokenSession) {
    return <ApplicationStatusButton className={className} />;
  }

  return (
    <Link to="/mi-cuenta" onClick={goLoan} className={className}>
      <Button
        variant="ghost"
        scale="small"
        className="w_100_per bg_primary_25 text_primary_300"
      >
        Mi cuenta
      </Button>
    </Link>
  );
};
